import { render, staticRenderFns } from "./titleNameSwitch.vue?vue&type=template&id=a42c1060&lang=true&"
import script from "./titleNameSwitch.vue?vue&type=script&lang=js&"
export * from "./titleNameSwitch.vue?vue&type=script&lang=js&"
import style0 from "./titleNameSwitch.vue?vue&type=style&index=0&id=a42c1060&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports